import { tagNameEquals } from '@/lib/tag'
import { cn } from '@/lib/utils'
import { Event } from '@nostr/tools/wasm'
import { useMemo } from 'react'
import Content from '../Content'
import Nip29EventHeader from './Nip29EventHeader'

export default function ForumThread({
  event,
  className,
  clamp,
  showFull
}: {
  event: Event
  className?: string
  clamp?: boolean
  showFull?: boolean
}) {
  const title = useMemo(() => event.tags.find(tagNameEquals('title'))?.[1], [event])

  return (
    <div className={cn('space-y-2', className)}>
      <Nip29EventHeader event={event} label="Forum Topic" />
      {title && (
        <div className={cn('text-xl font-semibold', !showFull && 'line-clamp-2')}>{title}</div>
      )}
      <Content
        event={event}
        clamp={clamp}
        className={showFull ? 'font-serif text-lg' : undefined}
      />
    </div>
  )
}
